var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOff = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "52px",
    viewBox: "0 0 52 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M26.0051883,0 C24.4166165,0 23.1168759,1.30039447 23.1168759,2.8897655 L23.1168759,26.0078895 C23.1168759,27.5972605 24.4166165,28.897655 26.0051883,28.897655 C27.5937601,28.897655 28.8935007,27.5972605 28.8935007,26.0078895 L28.8935007,2.8897655 C28.8935007,1.30039447 27.5937601,0 26.0051883,0 Z M40.8511141,8.26472933 C39.7246722,9.39173787 39.7535554,11.1544948 40.822231,12.2815034 C44.086024,15.749222 46.1078427,20.3728468 46.2233752,25.4877317 C46.4833233,36.5555336 37.3273729,46.0917597 26.2651364,46.2073503 C14.9718349,46.3807363 5.78700141,37.2779749 5.78700141,26.0078895 C5.78700141,20.690721 7.83770322,15.8648126 11.1881456,12.2526057 C12.2568212,11.1255972 12.2568212,9.36284022 11.1592625,8.26472933 C10.0039375,7.10882313 8.12653446,7.13772078 7.02897574,8.32252464 C2.84092275,12.7727635 0.212558452,18.6967828 0.0103765835,25.2565505 C-0.393987154,39.3586061 11.0726131,51.5534165 25.1675777,51.9868813 C39.897971,52.4492438 52,40.6301029 52,25.9789918 C52,19.1302476 49.3427526,12.9461494 45.010284,8.32252464 C43.9127252,7.13772078 42.0064391,7.10882313 40.8511141,8.26472933 L40.8511141,8.26472933 Z",
    id: "path-off"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI/Header",
    transform: "translate(-1842.000000, -28.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Atom/icons/off",
    transform: "translate(1842.000000, 27.000000)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#path-off"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOff);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/off.de3c0db03b5a875e99d4987468ce149e.svg";